<template lang="pug">
  v-dialog(v-model="show" max-width="700" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" persistent )
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackBar = false") {{ $t('buttons.closeButtonLabel') }}
    AddNewSubGroupDialog(
      v-if="showAdNewSubGroupDialog"
      :show="showAdNewSubGroupDialog"
      @save="onSaveNewSubGroup"
      @close="onCloseNewSubGroupDialog"
      )
    AddNewSlotDialog(
      :show="showAdNewSlotDialog"
      v-if="showAdNewSlotDialog"
      :tagList="tagList"
      @save="onSaveNewSlot"
      @close="onCloseNewSlotDialog")
    v-card.d-flex.flex-column.overflow-auto(flat v-if="selectedTopGroup && $vuetify.breakpoint.smAndUp" )
      v-card-title.headline {{ $t('settingsPage.offerStructure.updateGroupLabel') }}
      v-card-text.overflow-auto(style="height: 500px")
        v-tabs
          v-tab Detail
          v-tab-item
            v-row.ma-0.align-self-start
              v-col(cols="12")
                v-text-field(outlined v-model="topGroupName" :label="$t('settingsPage.offerStructure.nameLabel')" autofocus)
            v-row.ma-0.align-self-center
              v-col.pl-1.pt-0(cols="12" align="center" )
                v-select.ml-2.text-center.text-justify-center(
                    height="56px"
                    :items="tagList"
                    :label="$t('settingsPage.labelLabel')"
                    item-text="title"
                    item-value="id"
                    v-model="selections"
                    color="primary"
                    multiple
                    append-icon="fas fa-chevron-down"
                    chips
                    return-object
                    outlined)
                    template( v-slot:selection="{ item, index }")
                      v-chip
                        v-icon.mr-4(left) {{getIcon(item.iconClass)}}
                        span {{item.title}}
                    template(v-slot:item="{active, item, attrs, on }")
                      v-list-item(v-slot:default="{ active }" v-on="on" v-bind="attrs" )
                        v-list-item-action
                          v-checkbox(
                            :input-value="active"
                            on-icon="fas fa-check-square"
                            off-icon="far fa-square" )
                        v-list-item-content
                          v-list-item-title
                            v-icon.mr-4 {{getIcon(item.iconClass)}}
                            span {{item.title}}

            v-row.ma-0.align-self-start
              v-col.text-end(cols="12")
                v-btn(color="primary" @click="onSubmitButtonClick" :loading="loading") {{ $t('settingsPage.offerStructure.slotEditorSaveButtonLabel') }}
          v-tab {{ $t('settingsPage.offerStructure.subGroupLabel') }}
          v-tab-item.overflow-auto(style="height: 400px")
            v-row.ma-0.align-self-start
              v-col.text-center(cols="12")
                v-btn.align-self-center(v-if="selectedTopGroup && selectedTopGroup.isTopMenuGroup" color="primary" @click="onShowSubGroupDialogClick") {{ $t('settingsPage.offerStructure.addNewSubGroup') }}
                span(v-else) {{ $t('settingsPage.offerStructure.subGroupMessage') }}
            v-row.ma-0.align-self-start
              v-col(cols="12")
                v-list(:disabled="fetchInProgress" dense)
                  draggable(
                    ghost-class="grey"
                    v-model="draggableSubGroupList"
                    @change="onDraggableSubGroupsChange")
                    template(v-for="(item) in draggableSubGroupList")
                      v-list-item.subtitle-1.listItem.elevation-1.mb-2
                        v-icon.pr-4(small) fal fa-bars
                        span {{item.order}}. {{item.title}}
          v-tab {{ $t('settingsPage.offerStructure.slots') }}
          v-tab-item.overflow-auto(style="height: 400px")
            v-row.ma-0.align-self-start
              v-col.pr-4.text-center(cols="12")
                v-btn.align-self-center(color="primary" @click="onShowNewSlotDialogClick") {{ $t('settingsPage.offerStructure.addNewSlot') }}
            v-row.ma-0.align-self-start(v-if="!open")
              v-expansion-panels(v-model="panel" multiple)
                draggable.slotStyle(
                  v-if="!open"
                  v-model="slotList"
                  @change="onDraggableChange"
                  draggable=".enableDrag")
                  template
                    MenuGroupSlotEditor(:slotItem="item" v-for="(item, idx) in slotList" :key="idx" :class="getDraggableClass(idx)" :tagList="tagList" @slotItemSave="slotItemSave")

      v-divider
      v-card-actions
        v-spacer
        v-btn( color="primary" text @click="onCancelButtonClick" :disabled="loading" ) {{ $t('settingsPage.offerStructure.cancel') }}
    v-card.d-flex.flex-column.overflow-auto(flat v-if="selectedTopGroup && $vuetify.breakpoint.xsOnly" )
      v-card-title.headline {{ $t('settingsPage.offerStructure.updateGroupLabel') }}
      v-card-text.overflow-auto(style="height: 500px")
        v-tabs
          v-tab {{ $t('settingsPage.offerStructure.detailLabel') }}
          v-tab-item
            v-row.ma-0.align-self-start
              v-col(cols="12")
                v-text-field(outlined v-model="topGroupName" :label="$t('settingsPage.offerStructure.nameLabel')" autofocus)
            v-row.ma-0.align-self-center
              v-col.pl-1(cols="12" align="center" )
                v-select.ml-2.mb-0.text-center(
                  height="56px"
                  outlined
                  :items="tagList"
                  :label="$t('settingsPage.labelLabel')"
                  item-text="title"
                  item-value="id"
                  v-model="selections"
                  color="primary"
                  multiple
                  append-icon="fas fa-chevron-down"
                  chips
                  return-object
                )
                  template( v-slot:selection="{ item, index }")
                    v-chip()
                      v-icon.mr-4(left) {{getIcon(item.iconClass)}}
                      span {{item.title}}
                  template(v-slot:item="{active, item, attrs, on }")
                    v-list-item(v-on="on" v-bind="attrs" v-slot:default="{ active }")
                      v-list-item-action
                        v-checkbox(
                          :input-value="active"
                          on-icon="fas fa-check-square"
                          off-icon="far fa-square" )
                      v-list-item-content
                        v-list-item-title
                          v-icon.mr-4 {{getIcon(item.iconClass)}}
                          span {{item.title}}
            v-row.ma-0.align-self-start
              v-col.text-end(cols="12")
                v-btn(color="primary" @click="onSubmitButtonClick" :loading="loading") {{ $t('settingsPage.offerStructure.slotEditorSaveButtonLabel') }}
          v-tab {{ $t('settingsPage.offerStructure.subGroupLabel') }}
          v-tab-item.overflow-auto(style="height: 400px")
            v-row.ma-0.align-self-start
              v-col.text-center(cols="12")
                v-btn.align-self-center(v-if="selectedTopGroup && selectedTopGroup.isTopMenuGroup" color="primary" @click="onShowSubGroupDialogClick") {{ $t('settingsPage.offerStructure.addNewSubGroup') }}
                span(v-else) {{ $t('settingsPage.offerStructure.subGroupMessage') }}
            v-row.ma-0.align-self-start
              v-col(cols="12")
                v-list(:disabled="fetchInProgress" dense)
                  draggable(
                    ghost-class="grey"
                    v-model="draggableSubGroupList"
                    @change="onDraggableSubGroupsChange")
                    template(v-for="(item) in draggableSubGroupList")
                      v-list-item.subtitle-1.listItem.elevation-1.mb-2
                        v-icon.pr-4(small) fal fa-bars
                        span {{item.order}}. {{item.title}}
          v-tab {{ $t('settingsPage.offerStructure.slots') }}
          v-tab-item.overflow-auto(style="height: 450px")
            v-row.ma-0.align-self-start
              v-col.pr-4.text-center(cols="12")
                v-btn.align-self-center(color="primary" @click="onShowNewSlotDialogClick") {{ $t('settingsPage.offerStructure.addNewSlot') }}
            v-row.ma-0.align-self-start(v-if="!open")
              v-expansion-panels(v-model="panel" multiple)
                draggable.slotStyle(
                  v-if="!open"
                  v-model="slotList"
                  @change="onDraggableChange"
                  draggable=".enableDrag")
                  template
                    MenuGroupSlotEditor(:slotItem="item" v-for="(item, idx) in slotList" :key="idx" :class="getDraggableClass(idx)" :tagList="tagList")
      v-divider
      v-card-actions
        v-spacer
        v-btn( color="primary" text @click="onCancelButtonClick" :disabled="loading" ) {{ $t('optOutDialog.cancelButtonLabel') }}


</template>

<script lang="ts">

import {Component, Prop, Watch} from "vue-property-decorator";
import Vue from 'vue';
import MenuGroupList from "@/model/menu/MenuGroupList";
import AddNewSubGroupDialog from "@/components/settings/AddNewSubGroupDialog.vue";
import AddNewSlotDialog from "@/components/settings/AddNewSlotDialog.vue";
import MenuGroupSlotEditor from "@/components/settings/MenuGroupSlotEditor.vue";
import {SlotPayload, TopGroupPayload} from "@/types/payload";
import draggable from "vuedraggable";
import {SlotCollectionResponse, SubGroupCollectionResponse} from "@/types/service-response";
import {Action} from "vuex-class";
import {FETCH_TAGS, SAVE_UPDATED_GROUP, UPDATE_SLOT_ORDER} from "@/store/action-types";
import _ from "lodash";
import Tag from "@/model/tennant/Tag";


@Component({
  components: {
    AddNewSubGroupDialog,
    AddNewSlotDialog,
    MenuGroupSlotEditor,
    draggable
  }
})

export default class MenuGroupDetail extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly closeDialog!: boolean
  @Prop({ type: Object, required: false }) readonly selectedTopGroup!: MenuGroupList
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Action(UPDATE_SLOT_ORDER) updateSlotOrder!: { (payload: SlotCollectionResponse): Promise<void> }
  @Action(SAVE_UPDATED_GROUP) saveUpdatedGroup!: ({ (payload: TopGroupPayload): Promise<MenuGroupList> })
  @Action(FETCH_TAGS) fetchTagList!: ({ (): Promise<Tag[]> })

  @Watch('selectedTopGroup')
  selectedGroup(newVal: MenuGroupList): void {
    if(newVal) {
      this.topGroupName = this.selectedTopGroup.title
      this.slotList = this.selectedTopGroup.menuGroupSlots
      this.slotList = _.orderBy(this.slotList, 'order')
      this.draggableSubGroupList = _.cloneDeep(this.selectedTopGroup.subMenuGroups)
    }
  }

  private name: string = ''
  private showAdNewSubGroupDialog: boolean = false
  private showAdNewSlotDialog: boolean = false
  private topGroupName: string = ''
  private slotList: SlotCollectionResponse[] = []
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private draggableSubGroupList: SubGroupCollectionResponse[] = []
  private fetchInProgress: boolean = false
  private open: boolean = false
  private panel: number[] = []
  private tagList: Tag[] | undefined = []
  private selections: any[] = []
  private select: any[] = []
  private checkbox: boolean = false

  @Watch('closeDialog')
  watchCloseDialog (newVal: any): void {

  }

  async onDraggableSubGroupsChange (): Promise<void> {
    let promiseList: Promise<void>[] = []
    this.draggableSubGroupList.forEach((item: SubGroupCollectionResponse, idx: number) => {
      item.order = idx+1
      promiseList.push(this.onUpdateSubGroup(item))
    })
    this.fetchInProgress = true
    await Promise.all(promiseList)
    this.fetchInProgress = false
    this.$emit('fetchData')
  }

  getIcon (item: string):string | null {
    if(item && item.length > 4) {
      return item  ? `fas ${item}` : null
    } else {
      return ''
    }
  }

  getDraggableClass (idx: number): string {
    return this.panel.includes(idx) ? '' : 'enableDrag'
  }

  slotItemSave () {
    this.$emit('saveUpdatedSlot')
  }

  onSubmitButtonClick (): void {
    this.$emit('saveTopGroupName', this.topGroupName,this.selections)
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  onSaveNewSubGroup (item: string): void {
    this.$emit('saveSubGroup', item)
    this.showAdNewSubGroupDialog = false
  }

  onShowSubGroupDialogClick (): void {
    this.showAdNewSubGroupDialog = true

  }

  onCloseNewSubGroupDialog (): void {
    this.showAdNewSubGroupDialog = false
  }

  onShowNewSlotDialogClick (): void {
    this.showAdNewSlotDialog = true
  }

  onCloseNewSlotDialog (): void {
    this.showAdNewSlotDialog = false
  }

  onSaveNewSlot (item: SlotPayload): void {
    this.$emit('saveSlot', item)
      if(this.closeDialog) {
        this.showAdNewSlotDialog = false
      }
  }

  getSelectedTagClick (item: any) {
    this.selections.push(item)
  }

  async onDraggableChange (item: SlotCollectionResponse): Promise<void> {
    let promiseList: Promise<void>[] = []
    this.slotList.forEach((item: SlotCollectionResponse, idx: number) => {
      item.order = idx+1
      promiseList.push(this.onUpdateOrderSlot(item))
    })
    await Promise.all(promiseList)
    this.$emit('fetchData')
  }

  async fetchTagData ():Promise<void> {
    try {
      this.fetchInProgress = true
      this.tagList = await this.fetchTagList()
      if(this.tagList) {
        this.selectedTopGroup.tags.forEach((item: any) => {
          const foundItem: Tag | undefined = this.tagList!.find((i: Tag) => i.id === item.id)
          if(foundItem) {
            this.selections.push(foundItem)
          }
        })
      }
    }catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorMessage').toString()
      this.snackBarColor = 'error'
    }finally {
      this.fetchInProgress = false
    }
  }

  async onUpdateOrderSlot (payload: any): Promise<void> {
    try {
      await this.updateSlotOrder(payload)
    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.snackbarErrorMessage').toString()
      this.snackBarColor = 'error'
    } finally {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'
    }
  }

  async onUpdateSubGroup (item: SubGroupCollectionResponse): Promise<void> {
    let slotCollection = item.menuGroupSlots.map((i: SlotCollectionResponse) => {
      return `/api/menu-group-slot/${i.id}`
    })
    const payload: TopGroupPayload = {
      id: item.id,
      data: {
        title: item.title,
        order: item.order,
        subMenuGroups: [],
        menuGroupSlots: slotCollection
      }
    }
    try {
      await this.saveUpdatedGroup(payload)
    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
      this.snackBarColor = 'error'
    } finally {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'
    }
  }


  mounted() {
    this.topGroupName = this.selectedTopGroup.title
    this.slotList = this.selectedTopGroup.menuGroupSlots
    this.slotList = _.orderBy(this.slotList, 'order')
    this.draggableSubGroupList = _.cloneDeep(this.selectedTopGroup.subMenuGroups)
    this.fetchTagData()
  }

}

</script>

<style lang="stylus" scoped>
.slotStyle {
  width: 100%;
}
.listItem {
  cursor pointer
}
</style>
